import { cn } from '../../lib/utils'

export function Input({ className, error, ...props }) {
  return (
    <input
      className={cn('input', error && 'input-error', className)}
      {...props}
    />
  )
}

export function Textarea({ className, error, ...props }) {
  return (
    <textarea
      className={cn('textarea', error && 'input-error', className)}
      {...props}
    />
  )
}

export function Select({ className, children, ...props }) {
  return (
    <select className={cn('select', className)} {...props}>
      {children}
    </select>
  )
}

export function Label({ className, required, children, ...props }) {
  return (
    <label className={cn('label', required && 'label-required', className)} {...props}>
      {children}
    </label>
  )
}

export function FormGroup({ className, children }) {
  return (
    <div className={cn('form-group', className)}>
      {children}
    </div>
  )
}

export function HelpText({ className, children }) {
  return (
    <span className={cn('helptext', className)}>
      {children}
    </span>
  )
}

export function ErrorText({ className, children }) {
  return (
    <span className={cn('error-text', className)}>
      {children}
    </span>
  )
}
